import { HTTP } from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const goodsPickingStore = {
    namespaced: true,
    state: {
    },
    actions: {
        getInvCustName({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/InvCustName', { txNum: param.txNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        verifyGoodsPicked({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/VerifyGoodsPicked', param).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        approveGoodsPicked({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/ApproveGoodsPicked', { userID: param.userID, pwd: param.pwd }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        saveGoodsPicked({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/SaveGoodsPicked', param).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
    }
};
export default goodsPickingStore;